import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import React,{useState,useMemo,useEffect}from'react';import FormattedRichMessage from'../components/FormattedRichMessage/FormattedRichMessage.js';import CombinedValidationErrorMessage from'../components/CombinedValidationErrorMessage/CombinedValidationErrorMessage.js';var uniqueFilter = function uniqueFilter(value, index, errors) {
  return errors.findIndex(function (error) {
    return value.message === error.message;
  }) === index;
};
function effectLocal(isCheckList, showValidationErrors, errors, setVisibleValidationErrors, combinedLabel, setShowCheckList) {
  if (!isCheckList) {
    if (!showValidationErrors || errors.length === 0) {
      setVisibleValidationErrors([]);
    } else if (combinedLabel && errors.length > 1) {
      var combinedError = /*#__PURE__*/React.createElement(CombinedValidationErrorMessage, {
        combinedLabel: combinedLabel,
        errors: errors
      });
      setVisibleValidationErrors([combinedError]);
    } else {
      var resultErrors = errors.map(function (errorDetail) {
        var _errorDetail$context, _errorDetail$context$;
        return /*#__PURE__*/React.createElement(FormattedRichMessage, {
          id: errorDetail.message,
          values: {
            fieldName: errorDetail === null || errorDetail === void 0 ? void 0 : (_errorDetail$context = errorDetail.context) === null || _errorDetail$context === void 0 ? void 0 : (_errorDetail$context$ = _errorDetail$context.label) === null || _errorDetail$context$ === void 0 ? void 0 : _errorDetail$context$.toLowerCase()
          }
        });
      });
      setVisibleValidationErrors(resultErrors || []);
    }
  } else if (errors.length === 0) {
    setVisibleValidationErrors([]);
    setShowCheckList(false);
  } else if (errors.length > 0 && showValidationErrors) {
    var _combinedError = '';
    setVisibleValidationErrors([_combinedError]);
  }
}
function useValidation(validations, value, label, combinedLabel, inputRef, isCheckList) {
  var _inputRef$current;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showValidationErrors = _useState2[0],
    setShowValidationErrors = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    visibleValidationErrors = _useState4[0],
    setVisibleValidationErrors = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showCheckList = _useState6[0],
    setShowCheckList = _useState6[1];
  var errors = useMemo(function () {
    var _result$error;
    if (!validations) {
      return [];
    }

    // Validate the value, and include ALL issues found (abortEarly would stop at the first error)
    var result = validations.label(label).validate(value, {
      abortEarly: false
    });
    return (result === null || result === void 0 ? void 0 : (_result$error = result.error) === null || _result$error === void 0 ? void 0 : _result$error.details.filter(uniqueFilter)) || [];
  }, [label, value, validations]);

  // Since setCustomValidity sets on the actual input and not in react state we need to ensure this is run on every re-render
  // eslint-disable-next-line no-unused-expressions
  inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.setCustomValidity(errors.length > 0 ? 'error' : ''); // NOSONAR

  useEffect(function () {
    effectLocal(isCheckList, showValidationErrors, errors, setVisibleValidationErrors, combinedLabel, setShowCheckList);
  }, [combinedLabel, showValidationErrors, errors, showCheckList, isCheckList]);
  return [visibleValidationErrors, setShowValidationErrors, errors, showCheckList, setShowCheckList];
}export{useValidation as default};